<section class="footer-Container-Section">
  <section class="">
    <!--middlesec-->
    <section *ngIf="activeSeasons$ | async as activeSeasons">
      <section>
        <div class="active-season__title">
          <span>{{ 'flu.dashboard.reserveFluTitle' | cxTranslate }}</span>
        </div>
        <section
          *ngIf="!(infContacts$ | async)"
          class="missing-contact-message">
          {{ 'flu.dashboard.missing-contact' | cxTranslate }}
        </section>
        <section *ngFor="let activeSeason of activeSeasons">
          <section
            class="d-flex active-season__reserve-container flex-column flex-sm-row gap-1 justify-content-between">
            <section class="col-md-5 p-0">
              <section class="season-header">
                {{ activeSeason.code }}
                {{ 'selectVaccines.season' | cxTranslate }}
              </section>
            </section>
            <section
              class="d-flex p-0"
              *ngIf="activeSeason?.isInPreorder && isPharmacyUser$ | async">
              <button
                class="c-button c-button--primary mr-5"
                *ngIf="!activeSeason.asmReserveOnly || (isEmulated | async)"
                [disabled]="!(infContacts$ | async)"
                (click)="onReserve(activeSeason.code)">
                {{ 'flu.dashboard.reserveFluStandard' | cxTranslate }}
              </button>
              <button
                class="c-button c-button--secondary"
                *ngIf="!activeSeason.asmReserveOnly || (isEmulated | async)"
                [disabled]="!(infContacts$ | async)"
                (click)="onReservePBI(activeSeason.code)">
                {{ 'flu.dashboard.reserveFluPBI' | cxTranslate }}
              </button>
            </section>
            <section
              class="d-flex p-0"
              *ngIf="activeSeason?.isInPreorder && !(isPharmacyUser$ | async)">
              <button
                class="c-button c-button--primary mr-5"
                *ngIf="!activeSeason.asmReserveOnly || (isEmulated | async)"
                [disabled]="!(infContacts$ | async)"
                (click)="onReserve(activeSeason.code)">
                {{ 'flu.dashboard.newRequest' | cxTranslate }}
              </button>
            </section>
          </section>
        </section>
      </section>
    </section>
  </section>
</section>
